module.exports = __webpack_public_path__ + "static/media/pita-wrap.0185902c.svg";